<template>
  <div id="app-container" :class="{ testcafe: isTestCafeEnabled() }">
    <suspense>
      <router-view />
    </suspense>
  </div>
</template>

<script lang="ts" setup>
import isTestCafeEnabled from '@/helpers/isTestCafeEnabled'
import { configureCompat } from 'vue'

configureCompat({
  MODE: 2,
  WATCH_ARRAY: false
})
</script>
